import Page from "@/Pages/Page";
import titleImage from '@images/media/pagina-doorplaatsing-blanco.png'
import imagePhoneFront from '@images/media/phone-front.png'
import React, {useState} from "react";
import styles from './OnlineCondoleanceregister.module.scss'
import Quote from "@/Molecules/Quote/Quote";
import TriBullet from "@/Molecules/TriBullet/TriBullet";
import imageBackgroundField from "@images/media/blurry-field.png";
import imageIpad from "@images/media/ipad.png";
import {relativeRoute} from "@/helpers/relativeRoute";
import SectionHeader from "@/Organisms/SectionHeader/SectionHeader";
import image from "@images/examples/kaarsje-resormeren.png";
import CallToAction from "@/Molecules/CallToAction/CallToAction";
export default function OnlineCondoleanceregister() {

  return (
    <Page title={'Online rouwpagina'} harvestId={10404}>

      <SectionHeader
        beige
        image={titleImage}
        title={'Blijf zichtbaar met Mensenlinq'}
        subtitle={'Plaats het overlijdensbericht ook online!'}
        content={<p>Met een doorplaatsing naar Mensenlinq.nl worden niet alleen krantlezers, maar ook mensen buiten de regio geïnformeerd over het overlijden van de dierbare.</p>}
      />


      <TriBullet/>


      <section>
        <div className="container cta">
          <div>
            <div>
              <h2 className={'mb-5'}>Overlijdensbericht klaar? Eenvoudig doorgeplaatst!</h2>

              <p>Bij het kiezen voor een doorplaatsing, wordt een <a href={relativeRoute('standaard-rouwpagina')}>standaard
                rouwpagina</a> (€19,35 inclusief btw) of een <a href={relativeRoute('uitgebreide-rouwpagina')}>uitgebreide
                rouwpagina</a> (€19,35 inclusief btw. Let op: vanaf maandag 2 juni €44,95 inclusief btw) aangemaakt waarop het overlijdensbericht zichtbaar is. </p>

              <p>De rouwadvertentie doorplaatsen kan op de volgende manieren:
                <ol className={styles.orderedList}>
                  <li>
                    <strong>Maak de wens voor doorplaatsing kenbaar bij de uitvaartondernemer.</strong>
                  </li>
                  <li>
                    <strong>Bij bestelling via Familieberichten.nl:</strong> Vink de optie aan dat het overlijdensbericht wordt doorgeplaatst naar Mensenlinq. Het overlijdensbericht wordt automatisch doorgeplaatst.
                  </li>
                  <li>
                    <strong>Bij bestelling per e-mail of telefoon:</strong> Geef aan dat het overlijdensbericht ook op Mensenlinq geplaatst moet worden. Onze klantenservice doet de rest.
                  </li>
                  <li>
                    <strong>Achteraf doorplaatsen:</strong> Mail de digitale kopie van de het overlijdensbericht naar <a
                    href={'mailto:info@mensenlinq.nl'}>info@mensenlinq.nl</a> met het verzoek tot het aanmaken van een
                    rouwpagina op Mensenlinq.
                  </li>
                </ol>

              </p>
            </div>
            <img src={imagePhoneFront} alt=""/>
          </div>
        </div>
      </section>

      <Quote content={`Door de doorplaatsing naar Mensenlinq kreeg ik steunbetuigingen van mensen die ik al jaren niet
        meer had gesproken en die anders nooit hadden geweten dat mijn man is overleden.
        Ook kreeg ik berichten van mensen die ik persoonlijk niet ken, maar die jarenlang samen hebben
        gewerkt met mijn man. Hun berichten gaven me een gevoel van verbondenheid en steun in die
        donkere dagen. Nu, maanden na zijn overlijden, vind ik het fijn om de rouwadvertenties en de
        condoleances nogmaals terug te lezen.`}
             author={'Hennie A. '}/>


      <CallToAction
        imageBackground={imageBackgroundField}
        imageFloating={imageIpad}
        title={'Vragen over de doorplaatsing?'}
        content={<>
          <p>De Mensenlinq klantenservice staat voor je klaar om je vragen te beantwoorden. Mail ons op <a
            href={'info@mensenlinq.nl'}>info@mensenlinq.nl</a>.</p>
          <a className="button" href={relativeRoute('contact')}>Contact</a>
        </>}
      />


    </Page>
  );
}
